import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import strengthOfESAndRelationship from "models/StrengthOfESAndRelationship";

class StrengthOfESAndRelationship extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data;
  }
  render() {
    return (
      <Fragment>
        <ReactHighcharts
          config={strengthOfESAndRelationship(
            this.props.data,
            this.props.xCategories
          )}
        />
      </Fragment>
    );
  }
}

StrengthOfESAndRelationship.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  xCategories: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default StrengthOfESAndRelationship;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/StrengthOfESAndRelationship.jsx